const TILE = `<svg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 48 48'><circle cx='0' cy='0' r='10' fill='%233E7E8C' fill-opacity='0.16'/><circle cx='48' cy='0' r='10' fill='%233E7E8C' fill-opacity='0.16'/><circle cx='0' cy='48' r='10' fill='%233E7E8C' fill-opacity='0.16'/><circle cx='48' cy='48' r='10' fill='%233E7E8C' fill-opacity='0.16'/><path d='M24 13 L35 24 L24 35 L13 24 Z' fill='%23E8813A' fill-opacity='0.20'/><circle cx='24' cy='24' r='4' fill='%23E9B44C'/></svg>`;

const AzulejoStrip = ({ testid }) => (
  <div
    aria-hidden="true"
    data-testid={testid || "azulejo-strip"}
    className="h-10 md:h-12 w-full border-y border-stone/60"
    style={{
      backgroundImage: `url("data:image/svg+xml,${TILE}")`,
      backgroundRepeat: "repeat-x",
      backgroundSize: "48px 48px",
      backgroundPosition: "center",
    }}
  />
);

export default AzulejoStrip;
